<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'

const { t } = useI18n()
const route = useRoute()
const backLinkTo: string | RouteLocationRaw = window.history.state?.back || { name: '2-templates' }
</script>

<template>
  <div>
    <div
      class="flex flex-col gap-4 px-4 py-8 md:px-10 xl:gap-8 xl:p-12"
    >
      <AppBackButton
        v-if="!route.path.startsWith('/2/template/create')"
        :to="backLinkTo"
        size="lg"
        class="-ml-2 mb-6"
      >
        {{ t('template.back-to-templates') }}
      </AppBackButton>

      <NuxtPage />
    </div>
  </div>
</template>
